const DWMap = {
  ops_summary: { api: 'ops_report', name: 'Ops Summary' },
  audit_log: { api: 'audit_report', name: 'Audit Log' },
  indent_count: { api: 'indent_count', name: 'Indent-Count' },
  legalEntityWiseInvoice: { api: 'legalEntityWiseInvoice', name: 'Freight Cost Metrics' },
  freightProvisionReport: { api: 'freightProvisionReport', name: 'Freight provision' },
  csdBifuration: { api: 'csdBifuration', name: 'CSD bifurcation' },
  disputAmountTransporter: { api: 'disputAmountTransporter', name: 'Disputed Amount at transporter level' },
  waivedoffAmtwithApprove: { api: 'waivedoffAmtwithApprove', name: 'Waived off amount with approver' },
  optimaAuditLog: { api: 'optimaAuditLog', name: 'Optima Audit Log' },
  payAuditLog: { api: 'payAuditLog', name: 'Pay Audit Log' },
  indent_with_material_invoice_status: { api: 'indent_material_invoice_status', name: 'Indent With Material Invoice Status' },
  transaction_summary_report_pack_bench: { api: 'transaction_summary_report_pack_bench', name: 'Transaction Summary Report - Pack Bench' },
  transaction_summary_report_packer: { api: 'transaction_summary_report_packer', name: 'Transaction Summary Report - Packer' },
  productivity_pack_bench: { api: 'productivity_pack_bench', name: 'Productivity - Pack Bench' },
  productivity_user: { api: 'productivity_user', name: 'Productivity - User' },
  transaction_detail_report: { api: 'transaction_detail_report', name: 'Transaction Detail Report' },
  shipment_status: { api: 'shipment_status', name: 'Shipment Status Report' },
  detentionreport: { api: 'detentionreport', name: 'Detention  Report' },
  transit_reliability: { api: 'transit_reliability', name: 'Transit Reliability Report' },
  exim_indent_status: { api: 'exim_indent_status', name: 'Exim Indent Status Report' },
  packing_freight_cost_report: { api: 'packing_freight_cost_report', name: 'Freight Cost Report' },
  carton_detail_report: { api: 'carton_details', name: 'Carton Detail Reporting' },
  indent_status: { api: 'indent_status', name: 'Indent Status Report' },
  import_indent_status: { api: 'import_indent_status', name: 'Import Indent Status Report' },
  optima_vs_dispatched_material: { api: 'optima_vs_dispatched_material', name: 'Optima vs Dispatch Material Report' },
  optima_vs_dispatched: { api: 'optima_vs_dispatched', name: 'Optima vs Dispatch Report' },
  modified_picklist: { api: 'modified_picklist', name: 'Modified Picklist Report' },
  payment_compliance: { api: 'compliance_report', name: 'Compliance Report', schema: 'paymentCompliance' },
  material_invoice_freight_spent: { api: 'material_invoice_freight_spent', name: 'Material Invoice Freight Spent' },
  rate_matrix_history: { api: 'rate_matrix_history', name: 'Rate Matrix History' },
  materialextractreport: { api: 'materialextractreport', name: 'Material Invoice and Delivery' },
  freightProvision_lrle: { api: 'freightProvision_lrle', name: 'Freight provision LR-LE Report' },
  movement_data: { api: 'movement_data', name: 'Movement Data' },
  tat_report: { api: 'tat_report', name: 'End to End TAT Tracking Report' },
  indents_wo_materials: { api: 'indents_wo_materials', name: 'Dispatched Indents Without Materials' },
  vehicle_types_bifurcation: { api: 'vehicle_types_bifurcation', name: 'Vehicle Types Bifurcation' },
  openStatusReport: { api: 'openStatusReport', name: 'Open Status Report' },
  exim_air_movement_import: { api: 'exim_air_movement_import', name: 'Exim Air Movement Import Report' },
  exim_air_movement: { api: 'exim_air_movement', name: 'Exim Air Movement Export Report' },
  open_market_placement: { api: 'open_market_placement', name: 'Open Market Placements Report' },
  secondary_adherence_epod: { api: 'secondary_adherence_epod', name: 'Seconadry EPOD Adherence Report' },
  shipment_unmapped: { api: 'shipment_unmapped', name: 'Shipment Unmapped' },
  unknown_materials_report: { api: 'unknown_materials_report', name: 'Unknown Materials' },
  bucc_bifurcation_report: { api: 'bucc_bifurcation_report', name: 'BUCC Bifurcation' },
  carbon_emission_report: { api: 'carbon_emission_report', name: 'Carbon Emission Report' },
  direct_dispatch_variance_report: { api: 'direct_dispatch_variance_report', name: 'Direct Dispatch Variance Report' },
  oel_fp_success_report: { api: 'oel_fp_success_report', name: 'OEL freight provision success report' },
  cbi_summary_report: { api: 'cbi_summary_report', name: 'Courier Integration Summary Report' },
  total_distance_report: { api: 'total_distance_report', name: 'Total Distance Report', schema: 'total_distance_report' },
  pr_debit_report: { api: 'pr_debit_report', name: 'PR Debit Report' },
  pr_debit_summary_report: { api: 'pr_debit_summary_report', name: 'PR Debit Summary Report' },
  shortage_damage_inbound_report: { api: 'shortage_damage_inbound_report', name: 'Overage, Shortage and Damage inbound Report' },
  contract_adherence: { api: 'contract_adherence', name: 'Contract Adherence Report' },
  package_reconciliation_report: { api: 'package_reconciliation_report', name: 'Package Reconciliation Report' },
  contract_forcast_report: { api: 'contract_forcast_report', name: 'Contract Forcast Vs Executed Report' },
  depot_wise_user_summary_report: { api: 'depot_wise_user_summary_report', name: 'Depot Wise User Summary Report' },
  monthly_fp_report_v2: { api: 'monthly_fp_report_v2', name: 'Monthly FP Report' },
  pg_msu_truck: { api: 'pg_msu_truck', name: 'MSU Per Truck Report' },
  cost_uom_km_metrics: { api: 'cost_uom_km_metrics', name: 'Cost UOM KM Metrics' },
  exceptions_data_report: { api: 'exceptions_data_report', name: 'Exceptions Summary Report' },
  indent_shortage_damage_report: { api: 'indent_shortage_damage_report', name: 'Indent Shortage and Damage Report' },
  actual_dispatch_throughput_report: { api: 'actual_dispatch_throughput_report', name: 'Actual Dispatch Throughput Report' },
  temperature_compliance_report: { api: 'temperature_compliance_report', name: 'Temperature Compliance Report' },
  reconciliation_dedicated_truck_report: { api: 'reconciliation_dedicated_truck_report', name: 'Reconciliation Dedicated Truck Report' },
  optima_savings_report: { api: 'optima_savings_report', name: 'Optima Savings Report' },
  future_contract_export: { api: 'future_contract_export', name: 'Future Contract Export' },
  delay_dispatch_summary: { api: 'delay_dispatch_summary', name: 'Delay Dispatch Summary' },
  delay_delivery_summary: { api: 'delay_delivery_summary', name: 'Delay Delivery Summary' },
  day_zero_service_performance_report: { api: 'day_zero_service_performance_report', name: 'Day zero Service Performance' },
  ontime_dispatch_summary_report: { api: 'ontime_dispatch_summary_report', name: 'On time Dispatch - Service Level Performance' },
  ontime_delivery_summary_report: { api: 'ontime_delivery_summary_report', name: 'On time Delivery - Service Level Performance' },
  vehicle_inspection_failed_indents: { api: 'vehicle_inspection_failed_indents', name: 'Vehicle Inspection Failed Indents' },
  day_zero_service_performance_report: { api: 'day_zero_service_performance_report', name: 'Service level Performance Report' },
  under_utilized_vehicle_summary: { api: 'under_utilized_vehicle_summary', name: 'Under Utilized Vehicle Approval Summary' },
  csp_booking_tracking_summary_report: { api: 'csp_booking_tracking_summary_report', name: 'CSP Booking & Tracking Summary Report' },
  freight_invoice_status_report: { api: 'freight_invoice_status_report', name: 'Freight Invoice status report' },
  timeline_summary_report: { api: 'timeline_summary_report', name: 'Indent Timelines Summary' },
  capacity_utilisation: { api: 'capacity_utilisation', name: 'Capacity Utilisation' },
  outbound_git: { api: 'outbound_git', name: 'Outbound GIT Report' },
  inbound_git: { api: 'inbound_git', name: 'Inbound-GIT-Report' },
  rfq: { api: 'rfq', name: 'RFQ-Report' },
  delay_report: { api: 'delay_report', name: 'Delay' },
  indent_split_combine_report: { api: 'indent_split_combine_report', name: 'Indent Split and Combine Report' },
  epod_summary_report: { api: 'epod_summary_report', name: 'ePoD Summary Report' },
  overageShortageDamage: { api: 'overageShortageDamage', name: 'Overage, Shortage and Damage Report' },
  top_up_report: { api: 'top_up_report', name: 'Top UP report' },
  delivery_report: {api: 'delivery_report', name: 'Delivery report'},
  freight_provision_report: { api: 'freight_provision_report', name: 'Freight Provision' },
  freight_provision_signify: {api: 'freight_provision_signify', name: 'Freight Provision'},
  transporter_indent_rejection_analysis_report: {api: 'transporter_indent_rejection_analysis_report', name: 'Transporter Indent Rejection Analysis Report'}
};

const transporterDWMap = {
  transporter_indent_status: { api: 'transporter_is_report', name: 'Transporter Indent Status' },
  transporter_freight_provision_report_lrle: { api: 'freightProvision_lrle', name: 'Freight provision LR-LE' },
  transporter_disput_amount: { api: 'disputAmountTransporter', name: 'Disputed Amount at transporter level' },
  material_extract_report: { api: 'materialextractreport', name: 'Material Invoice and Delivery' },
  delay_report: { api: 'report/delay_report', name: 'Delay' },
  indents_not_serviced: { api: 'indents_not_serviced', name: 'Transporter Indents Not Serviced Report' },
  freight_invoice_status_report: { api: 'freight_invoice_status_report', name: 'Freight Invoice status report' },
  indent_status_operational_report: {api: 'indent_status_operational_report', name: 'Indent Status Operational Report'}
};

const reportsResponseConstants = {
  ALL_MOVEMENTS: 'All Movements',
  ALL_Depots: 'All Depots',
  ALL_TRANSPORTERS: 'All Transporters',
};

const ReportRequestType = {
  SHIPPER: 1,
  TRANSPORTER: 2
};

const reportMap = {
  transporter_performance: { api: 'transporter_performance', name: 'Transporter Performance' },
  optima_vs_dispatched_material: { api: 'transporter_performance', name: 'Optima vs Dispatch Material Report' },
  track_and_trace: { api: 'track_and_trace', name: 'Track and Trace Report' },
  track_and_trace_gps: { api: 'track_and_trace_gps', name: 'Track and Trace Report - GPS' },
  driver_behaviour_report: { api: 'driver_behaviour_report', name: 'Driver Behaviour Report' },
  modified_picklist: { api: 'modified_picklist', name: 'Modified Picklist Report' },
  varianceSummaryDownload: { api: 'varianceSummaryDownload', name: 'Optima Variance Summary' },
  varianceDownload: { api: 'varianceDownload', name: 'Optima Variance' },
};

const reportStatus = {
  QUEUED: 1,
  READY: 2,
  FAILED: 3,
  EXPIRED: 4 ,
  NO_DATA: 5,
};

const reportDefaultHeaders = {
  indentCount: {
    depot_name: 'Depot Name',
    created_date: 'Indent Created',
    material_ref_id: 'Shipment',
    indents_count: 'Total Indents',
    indent_with_materials_count: 'Materials Uploaded',
    indent_with_pods_count: 'POD Updated',
  },
};
module.exports = {
  DWMap,
  transporterDWMap,
  reportDefaultHeaders,
  reportsResponseConstants,
  reportStatus,
  reportMap,
  ReportRequestType
};
